/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    function redirectToRegistry() {
        var registryLookup = {
            129736: 3336711,
            131731: 3336692,
            133163: 3336683,
            133259: 340686,
            135301: 3336680,
            136088: 3336677,
            136152: 3336674,
            136657: 3336671,
            137597: 3336666,
            139047: 3336662,
            139519: 3336657,
            139521: 3336653,
            139535: 3336719,
            139541: 3336717,
            139618: 3153925,
            139909: 3336710,
            139910: 3336929,
            140178: 3336707,
            140271: 3336704,
            140273: 3336700,
            140333: 3336634,
            140354: 3336630,
            140569: 3336628,
            140795: 3336624,
            141157: 3336579,
            141522: 3336574,
            141548: 3336571,
            141551: 3336567,
            141647: 3336650,
            141655: 3336646,
            141774: 2924887,
            142162: 3336615,
            142270: 3336613,
            146505: 3336607,
            146543: 3336604,
            146638: 3336599,
            146655: 3336593,
            146892: 3336590,
            146905: 3336585,
            147044: 3336581,
            147186: 3336577,
            147196: 3336572,
            147375: 3336568,
            147621: 3336565,
            147801: 3336559,
            147804: 3336556,
            148040: 3336555,
            148119: 3336551,
            148232: 3336548,
            148311: 3336545,
            148454: 3336538,
            148461: 3336536,
            148515: 3336532,
            148537: 3336529,
            148538: 3336522,
            148652: 3336517,
            148708: 3336512,
            148718: 3336508,
            148740: 3336504,
            148928: 3336501,
            149036: 3336499,
            149149: 2955067,
            149178: 3336496,
            149190: 3336492,
            149255: 3336489,
            149259: 3336487,
            149341: 3336919,
            149342: 3336480,
            149350: 3336477,
            149369: 3336473,
            149457: 3336472,
            149459: 3336918,
            149460: 3336467,
            149521: 3336463,
            149538: 3336461,
            149634: 3336455,
            149702: 3336450,
            149808: 3336386,
            149829: 3336383,
            149839: 3336379,
            150002: 3336374,
            150224: 325339,
            150353: 3336371,
            150409: 3336367,
            150411: 3336362,
            150453: 3336357,
            150455: 3336354,
            150543: 3336351,
            150596: 3336348,
            150720: 3336310,
            150742: 3336562,
            150807: 2998339,
            150815: 3336558,
            150833: 2992813,
            150932: 3336554,
            150944: 3336550,
            151152: 3336547,
            151244: 3336544,
            151335: 3336539,
            151354: 3336535,
            151356: 3336531,
            151418: 3336527,
            151443: 3336523,
            151451: 3336518,
            151503: 3336513,
            151511: 3336509,
            151531: 3336505,
            151767: 3336502,
            151773: 3336500,
            151787: 3336497,
            151989: 3336494,
            151997: 3336491,
            152092: 3336920,
            152093: 3336485,
            152128: 3336482,
            152198: 2898019,
            152208: 3336478,
            152230: 3336474,
            152232: 3336471,
            152310: 3336468,
            152325: 2532723,
            152374: 3336462,
            152375: 3336460,
            152409: 3336457,
            152616: 3336451,
            152621: 3336447,
            152728: 3336445,
            152747: 3336443,
            152775: 3336438,
            152778: 3336436,
            152976: 3336434,
            153052: 3336430,
            153072: 3336427,
            153088: 3336426,
            153094: 3336422,
            153101: 3336419,
            153142: 2997175,
            153151: 3336417,
            153166: 3336414,
            153184: 3336916,
            153270: 3336410,
            153276: 3336406,
            153289: 3010418,
            153389: 3336402,
            153500: 3336915,
            153509: 3336399,
            153606: 3336396,
            153686: 3336393,
            153778: 3010437,
            153796: 3046459,
            153798: 3336389,
            154186: 3336385,
            154192: 2722302,
            154302: 3336381,
            154303: 3336376,
            154389: 3336372,
            154478: 3336368,
            154499: 3336363,
            154500: 3336358,
            154540: 3336355,
            154578: 3336352,
            154631: 3336349,
            154766: 3336346,
            154776: 3336344,
            154837: 2981224,
            154861: 3336341,
            154879: 3336340,
            154888: 3336339,
            163829: 3336337,
            181689: 3336334,
            181773: 3336333,
            181791: 3336331,
            181912: 3336330,
            181975: 3336327,
            182066: 3336323,
            182098: 3336320,
            182214: 3034824,
            182218: 3336315,
            182305: 3336911,
            182309: 3336701,
            182318: 3336698,
            182398: 3336927,
            182401: 3037214,
            182417: 3336696,
            182419: 3336695,
            182436: 3336694,
            182505: 3336690,
            182509: 3336688,
            182536: 3336686,
            182539: 3336685,
            182554: 3336926,
            182572: 3336682,
            182638: 3336681,
            182675: 3336678,
            182757: 3336676,
            182846: 3336673,
            182912: 3336670,
            183043: 3336665,
            183044: 3336661,
            183422: 2954724,
            183431: 3336924,
            183447: 3336655,
            183529: 3336652,
            183538: 3336648,
            183742: 3336642,
            183757: 3336638,
            183759: 3336636,
            183789: 3336632,
            183818: 2697868,
            183868: 3336626,
            183988: 3336622,
            184015: 3336620,
            184033: 3336617,
            184133: 3051714,
            184167: 3336614,
            184182: 3336609,
            184186: 3336602,
            184420: 3336597,
            184469: 3336591,
            184485: 3336587,
            184550: 3336583,
            184586: 3336520,
            184604: 3336515,
            184623: 3336511,
            184720: 3336507,
            184807: 3336475,
            184842: 3336470,
            184848: 3336466,
            184977: 3336464,
            184982: 3336459,
            185011: 3336454,
            185012: 3336452,
            185013: 3336448,
            185018: 3092383,
            185019: 3336444,
            185024: 3336442,
            185133: 3336437,
            185179: 3336435,
            185295: 3336433,
            185438: 3336429,
            185465: 3336428,
            185560: 2980307,
            185571: 3336425,
            185698: 3336421,
            185821: 3336418,
            185826: 3336416,
            185844: 3336412,
            185846: 3336411,
            185893: 3336405,
            185917: 3336403,
            185957: 3336401,
            185980: 3336398,
            186068: 3001406,
            186079: 3336395,
            186115: 3336392,
            186120: 3336390,
            186294: 3336387,
            186387: 3336382,
            186401: 3336377,
            186417: 3336373,
            186420: 3336370,
            186541: 3336365,
            186549: 3336360,
            186557: 3336326,
            186631: 3092097,
            186636: 3336321,
            186727: 3336318,
            186748: 3336313,
            186828: 3336934,
            186854: 3336757,
            186858: 3336755,
            186880: 3336753,
            186960: 3336751,
            187098: 3336749,
            187117: 3336746,
            187132: 3336743,
            187165: 3336740,
            187259: 3336933,
            187267: 3336738,
            187355: 3336736,
            187358: 3336729,
            187442: 3336726,
            187449: 3336724,
            187470: 3336932,
            187471: 3336722,
            187521: 3336720,
            187627: 3336718,
            187787: 3336714,
            187789: 3336709,
            187899: 3145736,
            187959: 3336706,
            187985: 3336702,
            188106: 3336928,
            188183: 3336699,
            189884: 3336697,
            189899: 2973315,
            189948: 3336663,
            189983: 3336659,
            190127: 3127321,
            190129: 3336656,
            190487: 3336651,
            190559: 3336647,
            190779: 3336643,
            190783: 3336640,
            190799: 3133324,
            190870: 3336635,
            190882: 3336631,
            190886: 3336627,
            190890: 3336623,
            190965: 2558949,
            190977: 3336619,
            190978: 3336616,
            190983: 3336611,
            191066: 3336608,
            191068: 3336603,
            191071: 3336600,
            191172: 3336594,
            191205: 3336589,
            191292: 3336586,
            191299: 3336582,
            191374: 3336576,
            191376: 3336573,
            191404: 3336569,
            191446: 3336564,
            191504: 3336560,
            191512: 3336557,
            191519: 3336553,
            191667: 3142558,
            191791: 3336549,
            191836: 3336546,
            191842: 3336542,
            191845: 3336537,
            191872: 3336533,
            191924: 3336530,
            192040: 3336526,
            192079: 3336519,
            192091: 3336516,
            192209: 3336510,
            192310: 3336506,
            192312: 3336503,
            192360: 3336921,
            192392: 3153421,
            192393: 3336484,
            192401: 3336456,
            192402: 3336432,
            192403: 3336917,
            192404: 3336413,
            192411: 3336394,
            192412: 3336366,
            192413: 3336361,
            192417: 3336356,
            192512: 3336353,
            192520: 3336350,
            192605: 3336347,
            192613: 3336913,
            192623: 3336345,
            192645: 3336312,
            192715: 3336885,
            192727: 3336833,
            192739: 3336827,
            192758: 3336824,
            192762: 3336822,
            192768: 3336821,
            192913: 3336809,
            193043: 3336808,
            193230: 3336806,
            193256: 3336803,
            193258: 3336939,
            193262: 3336938,
            193269: 3336797,
            193368: 3336793,
            193377: 3336790,
            193380: 3336789,
            193385: 3336786,
            193472: 3336783,
            193511: 3336782,
            193527: 3336780,
            193538: 3336776,
            193550: 3336771,
            193554: 3336769,
            193626: 3336693,
            193631: 3336691,
            193639: 3336687,
            193658: 3336679,
            193699: 3336675,
            193948: 3336672,
            193976: 3336668,
            194005: 3336664,
            194007: 3336925,
            194010: 3336658,
            194118: 3172283,
            194285: 3336654,
            194291: 3336649,
            194404: 3170906,
            194411: 3336645,
            194439: 3336641,
            194529: 3336923,
            194536: 3336637,
            194565: 3336633,
            194585: 3336618,
            194718: 3153877,
            194861: 3336612,
            195009: 3336606,
            195020: 3336601,
            195030: 3336596,
            195031: 3336592,
            195041: 3336588,
            195133: 3336584,
            195212: 3336580,
            195273: 3336575,
            195286: 3238099,
            195291: 3336570,
            195326: 3336566,
            195419: 3336563,
            195427: 3336552,
            195471: 3336543,
            195486: 3336534,
            195625: 3336922,
            195628: 3336528,
            195635: 3336521,
            195733: 3336514,
            195739: 2975393,
            195754: 3210210,
            195880: 3336498,
            195913: 3336495,
            195919: 3336488,
            195935: 3336486,
            195942: 3336481,
            195943: 3336469,
            195948: 3336465,
            195962: 3336453,
            196007: 3336449,
            196099: 3336441,
            196112: 3336424,
            196248: 3336415,
            196305: 3336408,
            196344: 3336404,
            196345: 3336391,
            196357: 3336914,
            196446: 3336378,
            196455: 3336342,
            196473: 3336329,
            196475: 3336325,
            196486: 3336316,
            196630: 3336912,
            196643: 3336887,
            196646: 3185488,
            196729: 3336886,
            196754: 3190431,
            196778: 3336883,
            196782: 3336879,
            196902: 3191912,
            196912: 3336877,
            196917: 3336945,
            196920: 3336875,
            196922: 3336906,
            196996: 3336905,
            197035: 3336903,
            197055: 3336902,
            197072: 3336899,
            197173: 3168028,
            197183: 3336898,
            197291: 3336891,
            197301: 3336889,
            197308: 3336881,
            197380: 3336880,
            197403: 3336876,
            197436: 3336868,
            197646: 3336862,
            197668: 3336859,
            197681: 3336851,
            197703: 3336872,
            197719: 3336864,
            197723: 3209986,
            197792: 3336944,
            197830: 3336856,
            197835: 3336854,
            197854: 3336846,
            197918: 3245546,
            198050: 3336839,
            198097: 3336830,
            198214: 3305198,
            198225: 3336826,
            198352: 3336812,
            198380: 3336810,
            198385: 3336805,
            198502: 3336800,
            198521: 3336795,
            198637: 3336937,
            198640: 3317687,
            198796: 3336787,
            198810: 3336936,
            198819: 3336781,
            198935: 3336774,
            199041: 3336770,
            199045: 3212258,
            199109: 3336768,
            199200: 3336766,
            199204: 3336763,
            199213: 3336761,
            199219: 3336760,
            199356: 3336732,
            199381: 3336727,
            199506: 3336716,
            199508: 3336930,
            199665: 3336703,
            199676: 3336689,
            199679: 3175145,
            199808: 3301572,
            199955: 3336621,
            200021: 3132823,
            200086: 3229587,
            200156: 3257707,
            200303: 3264800,
            200333: 3336598,
            200346: 3336578,
            200494: 3254993,
            200518: 3336476,
            200709: 3336458,
            200740: 3336440,
            200902: 3336409,
            200904: 3223341,
            200907: 3229739,
            200939: 3229881,
            200966: 3336384,
            201001: 3336380,
            201010: 3336375,
            201018: 3336335,
            201039: 3336322,
            201150: 3336319,
            201254: 3336317,
            201303: 3231393,
            201412: 3211684,
            201440: 3336871,
            201480: 3336867,
            201763: 3336860,
            201782: 3336858,
            201855: 3336853,
            202008: 3336845,
            202020: 3336837,
            202100: 3336941,
            202239: 3336825,
            202259: 3336818,
            202267: 3243019,
            202276: 3336897,
            202291: 3336894,
            202392: 3336890,
            202398: 3336874,
            202406: 3336870,
            202514: 3336866,
            202553: 3245611,
            202565: 3336863,
            202569: 3336855,
            202676: 3336844,
            202680: 3336843,
            202681: 3336836,
            202769: 3336820,
            202785: 3336816,
            202856: 3248404,
            202919: 3336895,
            202926: 3336893,
            202987: 3336888,
            203019: 3336878,
            203030: 3336873,
            203039: 3336865,
            203101: 3336861,
            203109: 3336852,
            203219: 3336942,
            203263: 3336849,
            203265: 3336835,
            203284: 3336832,
            203294: 3336823,
            203377: 3336819,
            203382: 3336814,
            203399: 3336811,
            203494: 3336909,
            203567: 3336907,
            203697: 3336904,
            203725: 3336900,
            203852: 3336896,
            203974: 3336892,
            204058: 3336884,
            204118: 3336882,
            204130: 3336857,
            204211: 3336943,
            204245: 3336847,
            204371: 3336841,
            204467: 3336829,
            204483: 3336785,
            204487: 3336935,
            204616: 3264769,
            204742: 3336850,
            204767: 3336848,
            204818: 3336842,
            204940: 3336840,
            204945: 3336838,
            204987: 3336834,
            204994: 3336794,
            205201: 3332019,
            205228: 3336767,
            205229: 3336713,
            205240: 3336669,
            205356: 3336629,
            205459: 3336625,
            205500: 3336610,
            205502: 3336605,
            205511: 3336595,
            205630: 3336561,
            205640: 3276813,
            205698: 2978439,
            205718: 3336541,
            205723: 3336524,
            205728: 3336493,
            205751: 3336490,
            205915: 3336479,
            206268: 3336439,
            206423: 3336431,
            206497: 3336407,
            206606: 3336369,
            206619: 3336364,
            206758: 3336359,
            206835: 3336311,
            206836: 3336815,
            206842: 3336813,
            207183: 3288452,
            207214: 3336807,
            207301: 3336802,
            207322: 3336792,
            207356: 3336788,
            207426: 3291720,
            207447: 3336778,
            207478: 3336759,
            207493: 3336869,
            207587: 3336831,
            207610: 3336817,
            207624: 3336804,
            207626: 3336940,
            207689: 3336798,
            207747: 3336784,
            207763: 3336775,
            207771: 3336752,
            207883: 3336750,
            207908: 3336747,
            208063: 3336741,
            208179: 3278398,
            208246: 3336737,
            208251: 3336725,
            208384: 3336721,
            208508: 3300532,
            208519: 2347253,
            208744: 3336779,
            208745: 3336773,
            208761: 3336764,
            208765: 3336754,
            208793: 3336744,
            208854: 3336739,
            208921: 3336734,
            208995: 3293135,
            209043: 3336733,
            209171: 3247008,
            209185: 3174491,
            209286: 3282739,
            209389: 3336728,
            209423: 3336715,
            209435: 3336801,
            209497: 3262441,
            209634: 3336777,
            209746: 3336765,
            209757: 3284788,
            209891: 3336762,
            209904: 3336748,
            209937: 3336745,
            210046: 3309569,
            210378: 3336735,
            210380: 3336730,
            210389: 3336723,
            210457: 3336931,
            210518: 3336712,
            210522: 3336708,
            210524: 3336705,
            210577: 3336799,
            210664: 3336796,
            210673: 3336791,
            210674: 3336772,
            210676: 3320567,
            210761: 3336758,
            210793: 3336756,
            210806: 3322246,
            210921: 3336742,
            210928: 3336731,
            210934: 3336684,
            211030: 3336667,
            211034: 3336660,
            211099: 3336644,
            211112: 3336639,
            211134: 3336540,
            211136: 3336525,
            211229: 3336483,
            211249: 3336446,
            211256: 3336423,
            211312: 3336420,
            211332: 3336400,
            211631: 3336397,
            211634: 3336343,
            211950: 3336338,
            212067: 3336336,
            212185: 3336332,
            212187: 3299583,
            212190: 3336328,
            212248: 3336324,
            212304: 3336314
        };
        var urlData = document.location.pathname.match(/\/apps\/giftregistry\/registry\/([0-9]+)/i);

        if (urlData && urlData[1] && registryLookup[urlData[1]]) {
            window.location = 'https://metro-baby.com.au/pages/gift-registry?mrrid=' + registryLookup[urlData[1]];
        } else {
            window.location = 'https://metro-baby.com.au/pages/gift-registry';
        }
    }

    if (/^\/apps\/giftregistry/.test(location.pathname)) {
        Mojito.utils.domReady(redirectToRegistry);
    }
})();
